import * as React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Grid, GridColumn as Column, GridCell, GridNoRecords, GridSortChangeEvent } from '@progress/kendo-react-grid';
import { SortDescriptor, orderBy } from '@progress/kendo-data-query';
import { fetchApi } from '../../services/api';
import LoadingPanel from '../LoadingPanel';
const DocumentTitle = require('react-document-title');

type Props = RouteComponentProps<{}>;

type State = {
    sort: SortDescriptor[];
    teachers: Teacher[];
    isLoading: boolean;
}

export interface Teacher {
    TeacherId: number;
    TeacherName: string;
    SchoolName: string;
}

class TeacherNameCell extends GridCell {
    render() {
        return (
            <td>
                <Link style={{ color: '#007bff' }} to={`/teacher/${this.props.dataItem.TeacherId}`}>
                    {this.props.dataItem.TeacherName}
                </Link>
            </td>
        );
    }
}

class SchoolNameCell extends GridCell {
    render() {
        return (
            <td>
                <span>{this.props.dataItem.SchoolName}</span>
            </td>
        );
    }
}

class Teachers extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            teachers: [],
            isLoading: false,
            sort: [{field: "TeacherName", dir: "asc"}],
        };

        this.getTeachers = this.getTeachers.bind(this)
        this.sortChange = this.sortChange.bind(this);
    }

    public componentWillMount() {
        // This method runs when the component is first added to the page
        this.getTeachers();
    }

    public render() {
        return <React.Fragment>
            <DocumentTitle title="Teachers" />
            <div className="row">
                <div className="col">
                    <h1>Teachers</h1>
                </div>
                <div className="col">
                    <Link
                        role="button"
                        className="btn btn-primary float-right"
                        to={ '/teacher/0' }
                    >
                        Add Teacher
                    </Link>
                </div>
            </div>
            {this.state.isLoading && <LoadingPanel />}
            <Grid data={this.state.teachers}
                sortable={{
                    allowUnsort: true
                }}
                sort={this.state.sort}
                onSortChange={this.sortChange}
                pageable={{
                    buttonCount: 0,
                    info: true,
                    type: 'numeric',
                    pageSizes: false,
                    previousNext: false
                }}
                skip={0}
                take={this.state.teachers.length}
                total={this.state.teachers.length}>
                <GridNoRecords>
                    No teachers found, you can add new teachers <Link style={{ color: '#007bff' }} to='/teacher/0'>Here</Link>.
                </GridNoRecords>
                <Column field="TeacherName" title="Name" cell={TeacherNameCell} />
                <Column field="SchoolName" title="School" cell={SchoolNameCell} />
            </Grid>
            <br />
        </React.Fragment>;
    }

    private sortChange(event: GridSortChangeEvent) {
        this.setState({
            sort: event.sort,
            teachers: orderBy(this.state.teachers, event.sort)
        });
    }

    private getTeachers() {
        this.setState({ isLoading: true });
        fetchApi('api/Teacher/List', {}, 'POST')
            .then((teachers: Teacher[]) => {
                this.setState({ teachers: orderBy(teachers, this.state.sort), isLoading: false });
            });
    }
}

export default Teachers;
